import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ArrowDown } from 'lucide-react';
export function Mapa5RSection() {
  const steps = [{
    icon: '🧊',
    title: 'Rompe el hielo',
    desc: 'Inicia la conversación sin parecer vendedor.'
  }, {
    icon: '🎯',
    title: 'Relevancia',
    desc: 'Demuestra que entiendes su problema.'
  }, {
    icon: '✨',
    title: 'Resultado',
    desc: 'Muestra la transformación posible.'
  }, {
    icon: '🛡️',
    title: 'Riesgo',
    desc: 'Elimina el miedo a equivocarse.'
  }, {
    icon: '🗺️',
    title: 'Ruta',
    desc: 'Guía clara hacia el pago.'
  }];
  return <section className="w-full bg-gray-50 py-20 px-4 sm:px-6 lg:px-8" data-id="element-98">
      <div className="max-w-5xl mx-auto" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-100">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1A1A1A] mb-4" data-id="element-101">
            El Mapa 5R: tu brújula de cierre
          </h2>
          <p className="text-gray-600 text-lg" data-id="element-102">
            Para que nunca más una conversación se vaya a la nada.
          </p>
        </motion.div>

        <div className="relative" data-id="element-103">
          {/* Connecting Line (Desktop) */}
          <div className="hidden lg:block absolute top-12 left-0 w-full h-1 bg-gray-200 -z-0 rounded-full" data-id="element-104"></div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-4" data-id="element-105">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="relative z-10 flex flex-col items-center text-center group" data-id="element-106">
                <div className="w-24 h-24 bg-white rounded-full shadow-lg border-4 border-[#DCF8C6] flex items-center justify-center text-4xl mb-6 group-hover:scale-110 transition-transform duration-300 group-hover:border-[#0B6B3A]" data-id="element-107">
                  {step.icon}
                </div>

                {/* Mobile Arrow */}
                {index < steps.length - 1 && <div className="lg:hidden text-gray-300 my-2" data-id="element-108">
                    <ArrowDown className="w-8 h-8" data-id="element-109" />
                  </div>}

                <h3 className="text-xl font-bold text-[#1A1A1A] mb-2" data-id="element-110">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 px-2" data-id="element-111">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}